// Central handler for an expired / invalid session (HTTP 401).
//
// "Clean logout": clear BOTH tokens and hard-redirect to /login. A hard redirect
// (full reload) also resets the Redux store, so the app returns to a pristine
// logged-out state. Used by every axios instance's response interceptor so a 401
// anywhere logs the user out consistently — previously each instance dropped only
// `accessToken` and left `refreshToken` behind.
let redirecting = false;

export function handleUnauthorized(): void {
  // Guard against a burst of concurrent 401s each triggering a navigation.
  if (redirecting) return;

  const onLoginPage = window.location.pathname.includes('/login');
  const hadSession =
    !!localStorage.getItem('accessToken') || !!localStorage.getItem('refreshToken');

  // Always clear credentials, even on the login page (nothing stale lingers).
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');

  // Only bounce to login if we actually had a session and aren't already there.
  if (hadSession && !onLoginPage) {
    redirecting = true;
    window.location.href = '/login';
  }
}
